import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'abortcontroller-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import CentersLocator from "./CentersLocator";

var appState = {
		selectedCenterID : null,
}
export const AppState = React.createContext(appState);

ReactDOM.render(
  <React.StrictMode>
		  <AppState.Provider value={appState}>
        <CentersLocator />
		  </AppState.Provider>
  </React.StrictMode>,
  document.getElementById('pharmacies-locator-root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
